import React from 'react';
import { Box, Typography, useMediaQuery, styled } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import Nacos from './../images/speaking/NacosAptech.JPG';


const OtherSpeakingEngagements = () => {
    const desktopView = useMediaQuery('(min-width:1093px)');

    const StyledBox = styled(Box)`
        width: 100%;
        padding: ${desktopView ? '0 100px' : '0 20px'};
        margin-top: 80px;
    `;

    // Additional speaking engagements data
    const otherEngagements = [
        {
            id: 1,
            title: 'Working With APIs as a Product Manager',
            role: 'Workshop Facillitator',
            organizer: 'Loubby AI',
            organizer_url: 'https://www.loubby.ai/',
            session_format: 'Virtual',
            session_url: 'https://www.youtube.com/watch?v=OFqZ_MKECH0'
        },
        {
            id: 2,
            title: 'Why Product Managers Struggle In Startups',
            role: 'Speaker',
            organizer: 'StartUp Grind Ilorin',
            organizer_url: 'https://www.startupgrind.com/ilorin/',
            session_format: 'Virtual',
            session_url: 'https://www.startupgrind.com/events/details/startup-grind-ilorin-presents-why-product-managers-struggle-in-startups/'
        },
         {
            id: 3,
            title: 'Building Products with Impact',
            role: 'Speaker',
            organizer: 'Newbii Africa',
            organizer_url: 'https://www.newbiiafrica.com/',
            session_format: 'Virtual',
            session_url: 'https://drive.google.com/file/d/1fbI6rjUcNqmh_oXcXIscxes9oRoWvL9P/view?usp=sharing'
        },
        {
            id: 4,
            title: 'How To Turn Real Ideas Into Products',
            role: 'Speaker',
            organizer: 'Product Sprinkle',
            organizer_url: 'https://www.linkedin.com/posts/product-sprinkle_productmanagement-earlystagestartups-productsprinkle-activity-7336079680019558402-YJns/?utm_source=share&utm_medium=member_desktop&rcm=ACoAADEQx-IBSIAD0UhI_ZnLn5GsDFOaapAVhoM',
            session_format: 'Virtual',
            session_url: 'https://drive.google.com/file/d/1wB6UR4B-sX9_WwJc8KBCGGBmp3AL4be3/view?usp=sharing_eil_se_dm&ts=6867bc13]'
        },
        {
            id: 5,
            title: 'Tech and what noottss',
            role: 'Moderator & Host',
            organizer: 'Aminat Fowoke Balogun',
            organizer_url: 'https://www.linkedin.com/in/aminatfowokebalogun/',
            session_format: 'Virtual',
            session_url: 'https://www.youtube.com/channel/UCxG4a8jMRdcYUUk_5E2WC3w?app=desktop'
        },
         {
            id: 6,
            title: 'Female Technology in Nigeria',
            role: 'Moderator & Host',
            organizer: 'FemaleTechNg',
            organizer_url: 'https://x.com/Femaletechng',
            session_format: 'Virtual',
            session_url: 'https://medium.com/@femaletechng/female-technology-in-nigeria-8041da29f0fb'
        },
         {
            id: 7,
            title: 'Crafting a career path in tech',
            role: 'Moderator',
            organizer: 'GDSoC Unilorin',
            organizer_url: 'https://www.linkedin.com/company/gdg-on-campus-university-of-ilorin/',
            session_format: 'Physical',
            session_url: 'https://www.linkedin.com/posts/devdesiignn_google-career-students-activity-6867861296134656000-zrJv?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAADEQx-IBSIAD0UhI_ZnLn5GsDFOaapAVhoM'
        },

    ];

    // Define columns for the table
    const columns = [
        {
            field: 'title',
            headerName: 'Title',
            width: 350,
            headerClassName: 'table-header',
        },
        {
            field: 'role',
            headerName: 'Role',
            width: 200,
            headerClassName: 'table-header',
        },
        {
            field: 'session_url',
            headerName: 'Watch Video',
            width: 250,
            headerClassName: 'table-header',
            renderCell: (params) => (
                <a 
                    href={params.value} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{
                        color: '#1976d2',
                        textDecoration: 'underline',
                        cursor: 'pointer'
                    }}
                >
                    {params.value}
                </a>
            ),
        },
        {
            field: 'session_format',
            headerName: 'Session Format',
            width: 180,
            headerClassName: 'table-header',
        },
        {
            field: 'organizer',
            headerName: 'Organizer',
            width: 200,
            headerClassName: 'table-header',
            renderCell: (params) => (
                <a 
                    href={params.row.organizer_url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{
                        color: '#1976d2',
                        textDecoration: 'underline',
                        cursor: 'pointer'
                    }}
                >
                    {params.value}
                </a>
            ),
        },
    ];

    return (
        <StyledBox>
            <br/><br/>
            <Typography 
                style={{
                    fontFamily: "Oswald", 
                    textAlign: 'center', 
                    fontSize: '20px',
                    marginBottom: '40px'
                }}
            >
                <u>OTHERS</u>
            </Typography>

            <Box 
                sx={{ 
                    height: 'auto', 
                    width: '100%',
                    '& .table-header': {
                        fontFamily: 'Oswald',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        backgroundColor: '#f5f5f5',
                    },
                    '& .MuiDataGrid-cell': {
                        fontSize: '15px',
                        padding: '16px',
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#f9f9f9',
                    },
                }}
            >
                <DataGrid
                    rows={otherEngagements}
                    columns={columns}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    disableColumnMenu
                    hideFooterSelectedRowCount
                    autoHeight
                    sx={{
                        border: '1px solid #ddd',
                        '& .MuiDataGrid-columnHeaders': {
                            borderBottom: '2px solid #000',
                        },
                        '& .MuiDataGrid-columnSeparator': {
                            display: 'none',
                        },
                    }}
                />
            </Box>

            
            <br/><br/>

            <img 
                src={Nacos} 
                style={{ width: desktopView ? '50%' : '90%' , display:'block', marginLeft: 'auto', marginRight: 'auto'}} 
                alt="AppTech 2021" 
            />
           <div style={{ textAlign: 'center', marginTop: '8px' }}>
                <span>AppTech 2021 @CIS, University of Ilorin</span>
            </div>

            <br/><br/>
            <Typography 
                style={{
                    textAlign: 'center', 
                    fontSize: '16px',
                    lineHeight: '1.8',
                    color: '#666'
                }}
            >
                I’m always eager to share my knowledge and experiences while learning from others. If you’d like to connect or collaborate, feel free to reach out at 
                <b>
                    <a href="mailto:aminatbalogun00@gmail.com"> aminatbalogun00@gmail.com</a>  &#129311;&#10084;
                </b>
            </Typography>

        </StyledBox>
    );
};

export default OtherSpeakingEngagements;